export const memberWizardFields:any = {
  personal: [
    { id: 'ttl', label: 'Title', type: 'fa', req: 1, ops: {}, cp: { t: 'lcs', s: 'title' } },
    { id: 'fnm', label: 'First Name', type: 'tf', req: 1, ops: {} },
    { id: 'otn', label: 'Other Names', type: 'tf', req: 0, ops: {} },
    { id: 'lnm', label: 'Last Name', type: 'tf', req: 1, ops: {} },
    // { id: 'img', label: 'Image URL', type: 'tf', req: 0, ops: {} },
    { id: 'gid', label: 'Gender', type: 'fa', req: 1, ops: {}, cp: { t: 'lcs', s: 'gender' } },
    { id: 'ddb', label: 'Date of Birth', type: 'df', req: 1, ops: {} },
    { id: 'pob', label: 'Place of Birth', type: 'tf', req: 0, ops: {} },
    { id: 'cid', label: 'Country', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'country' } },
    { id: 'hmt', label: 'Hometown', type: 'tf', req: 0, ops: {} },
    { id: 'rdd', label: 'Home District', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'district' } },
    { id: 'hrd', label: 'Home Region', type: 'fa', req: 0, ops: {}, cp: { t: 'bcs', s: 'region' } },
  ],
  contact: [
    { id: 'rad', label: 'Residential Address', type: 'ta', req: 1, ops: {} },
    { id: 'rpa', label: 'Postal Address', type: 'ta', req: 0, ops: {} },
    { id: 'ema', label: 'Email', type: 'tf', req: 1, ops: { type: 'email' } },
    { id: 'con', label: 'Primary Contact', type: 'pn', req: 1, ops: { type: 'tel' } },
    { id: 'ccn', label: 'Secondary Contact', type: 'pn', req: 0, ops: { type: 'tel' } },
    { id: 'gun', label: 'Guardian Name', type: 'tf', req: 0, ops: {} },
    { id: 'gcn', label: 'Guardian Contact', type: 'pn', req: 0, ops: { type: 'tel' } },
    { id: 'prn', label: 'Parent Name', type: 'tf', req: 0, ops: {} },
    { id: 'pmi', label: 'Parent Member', type: 'fa', req: 0, ops: {}, cp: { t: 'bcs', s: 'members' } },
  ],
  family: [
    { id: 'mrd', label: 'Marital Status', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'maritalstatus' }, chs: ['mti', 'mad', 'pom', 'spn', 'sid', 'spc', 'sdi', 'smi'] },
    { id: 'mti', label: 'Marriage Type', type: 'fa', req: 0, ops: {}, cp: { t: 'bcs', s: 'marriagetype' }, pns: ['mrd'] },
    { id: 'mad', label: 'Marriage Date', type: 'df', req: 0, ops: {}, pns: ['mrd'] },
    { id: 'pom', label: 'Place of Marriage', type: 'tf', req: 0, ops: {}, pns: ['mrd'] },
    { id: 'spn', label: 'Spouse Name', type: 'tf', req: 0, ops: {}, pns: ['mrd'] },
    { id: 'sid', label: 'Spouse Country', type: 'fa', req: 0, ops: {}, cp: { t: 'bcs', s: 'country' }, pns: ['mrd'] },
    { id: 'spc', label: 'Spouse Contact', type: 'tf', req: 0, ops: { type: 'tel' }, pns: ['mrd'] },
    { id: 'sdi', label: 'Spouse Denomination', type: 'fa', req: 0, ops: {}, cp: { t: 'bcs', s: 'religiousdenomination' }, pns: ['mrd'] },
    { id: 'smi', label: 'Spouse Member', type: 'fa', req: 0, ops: {}, cp: { t: 'bcs', s: 'members' }, pns: ['mrd'] },
  ],
  church: [
    { id: 'oid', label: 'Occupational Status', type: 'fa', req: 0, ops: {}, cp: { t: 'bcs', s: 'occupationalstatus' } },
    { id: 'ocd', label: 'Occupation', type: 'tf', req: 0, ops: {} },
    { id: 'pph', label: 'Previous Parish', type: 'tf', req: 0, ops: {} },
    { id: 'ppl', label: 'Previous Parish Location', type: 'tf', req: 0, ops: {} },
    // { id: 'gci', label: 'Day Group', type: 'fa', req: 0, ops: {}, cp: { t: 'bcs', s: 'groups' } },
    { id: 'tmd', label: 'Membership Date', type: 'df', req: 1, ops: {} },
    { id: 'exi', label: 'Extra Information', type: 'jf', req: 0, ops: {} },
    { id: 'sts', label: 'Record Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
  ],
  document: [
    { id: 'dti', label: 'Document Type', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'documenttype' } },
    { id: 'dfn', label: 'Document Reference No', type: 'tf', req: 1, ops: {} },
    { id: 'pno', label: 'Parish No', type: 'tf', req: 1, ops: {} },
  ],
};

export const memberReviewSections:any = [
  { key: 'personal', title: 'Personal Details', fields: memberWizardFields.personal },
  { key: 'contact', title: 'Contact & Guardian', fields: memberWizardFields.contact },
  { key: 'family', title: 'Family & Marriage', fields: memberWizardFields.family },
  { key: 'church', title: 'Church & Membership', fields: memberWizardFields.church },
  { key: 'document', title: 'Baptism Certificate', fields: [...memberWizardFields.document, { id: 'drl', label: 'Document URL' }] },
];

export const makeSectionConfig = (name:string, title:string, fields:any[]) => ({
  service: {
    name,
    title,
    eform: fields,
  },
  create: true,
  actions: { add: 'Add' },
  panels: { add: 'simple' },
});
